if (!process.env.AUTOMATION)
    //@ts-ignore
    Object.prototype[Symbol.toStringTag] = Object.prototype[Symbol.toStringTag]; 
